import React from 'react';
import { observer } from 'mobx-react';
import { BaasicDropdown, Loader, BaasicCheckbox, SliderCheckBox, BaasicButton } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { channelType } from 'common/constants';
import { CarrierServiceDeliveryDateAndRateOption } from 'core/components/select';
import _ from 'lodash';

const AssignCarrierServiceAndWarehouseTemplate = ({
	t,
	assignCarrierServiceAndWarehouseViewStore,
	assignCarrierServiceAndWarehouseViewStore: {
		loading,
		isBulkAction,
		isVendorOrder,
		isLtlOrder,
		form,
		form: { onSubmit, submitting },
		modalParams,
		isSuperAdminOrganization,
		warehouseDropdownStore,
		carrierServiceDropdownStore,
	},
}) => {
	if (loading || submitting) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.ASSIGNMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicDropdown dropdownStore={warehouseDropdownStore} className="spc--bottom--sml flex--grow--1" />
				<BaasicDropdown
					dropdownStore={carrierServiceDropdownStore}
					optionOverride={
						isBulkAction || isVendorOrder || isLtlOrder
							? null
							: {
									Component: CarrierServiceDeliveryDateAndRateOption,
							  }
					}
					className="spc--bottom--sml flex--grow--1"
				/>
				{!isSuperAdminOrganization ? (
					<UseBuyShippingDisplay {...{ assignCarrierServiceAndWarehouseViewStore, t }} />
				) : (
					<DeliverByDateDisplay {...{ assignCarrierServiceAndWarehouseViewStore, t }} />
				)}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
					type="submit"
					disabled={form.$('assignedCarrierServiceId').isEmpty || form.$('assignedWarehouseId').isEmpty}
					label="SAVE"
				/>
				<BaasicButton
					className="btn btn--med btn--secondary spc--bottom--sml"
					type="button"
					onClick={modalParams.close}
					label="BACK"
				/>
			</div>
		</form>
	);
};

const UseBuyShippingDisplay = observer(props => {
	const {
		assignCarrierServiceAndWarehouseViewStore: { selectedItem, isAllAmazon, onCheck, form },
		t,
	} = props;
	const displayBuyShipping =
		_.get(selectedItem, 'order.channel.channelType.name') === channelType.amazon || isAllAmazon;
	return (
		<React.Fragment>
			{displayBuyShipping ? (
				<div className="spc--bottom--sml">
					<BaasicCheckbox field={form.$('useBuyShipping')} onChangeCallback={onCheck} />
				</div>
			) : (
				<div className="spc--bottom--sml">{t('BUYSHIPPINGOPTIONDISABLED')}</div>
			)}
		</React.Fragment>
	);
});

const DeliverByDateDisplay = observer(props => {
	const {
		assignCarrierServiceAndWarehouseViewStore: { onIgnoreDeliverByDateChange, form, selectedItem, selectedItems },
		t,
	} = props;
	const displayBuyShippingOffWarning =
		_.get(selectedItem, 'order.channel.channelType.name') === channelType.amazon ||
		_.some(selectedItems, item => item.order.channel.channelType.name === channelType.amazon);
	return (
		<div className="flex--primary spc--bottom--sml">
			<div className="spc--right--xsml">
				<SliderCheckBox field={form.$('ignoreDeliverByDate')} onChangeCallback={onIgnoreDeliverByDateChange} />
			</div>
			<div>
				<label className="type--wgt--bold type--color--text">
					{t('FULFILLMENTORDER.ASSIGNMODAL.IGNOREDELIVERBYDATE')}
				</label>
				{displayBuyShippingOffWarning && (
					<span className="display--b type--color--grey-5">
						{t('FULFILLMENTORDER.ASSIGNMODAL.IGNOREDELIVERBYDATEFORAMAZON')}
					</span>
				)}
			</div>
		</div>
	);
});

export default defaultTemplate(AssignCarrierServiceAndWarehouseTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/AssignCarrierServiceAndWarehouseTemplate.jsx